<div
  class="network-location-members py-4"
  [ngClass]="
    !isHomePage && this.ccssService.getClass('navigation_background_color')
  "
>
  <ng-container *ngIf="!isMobile; else mobileContainer">
    <platform-page-container [fullscreen]="isHomePage" [contentSpacing]="false">
      <div
        class="flex"
        [ngClass]="{
          'justify-end': !isHomePage,
          'justify-center': isHomePage && !showMembersDropdown,
          'justify-between': isHomePage && showMembersDropdown
        }"
      >
        <span
          class="flex-1 high-contrast-theme w-[240px] my-auto underline dls-body-2-semibold"
          *ngIf="!isHomePage && isBillingCodeSearch"
        >
          <app-save-for-print [showPrintPageLink]="true"></app-save-for-print>
        </span>
        <span
          class="w-[240px]"
          [class.mr-6]="isHomePage && !authStatus"
          appUnfocus
        >
          <!-- network selection dropdown (wizard) -->
          <app-network-selection-dropdown
            *ngIf="
              networkSelectionDropdownEnabled | async;
              else desktopNetworkDropdown
            "
            [darkTheme]="true"
            appearance="fill"
          >
          </app-network-selection-dropdown>

          <!-- non-wizard/default network selection dropdown -->
          <ng-template #desktopNetworkDropdown>
            <app-global-network-dropdown
              analytics
              [darkTheme]="true"
              [showTout]="true"
              [showAlphaPrefixTout]="true"
              appearance="fill"
            >
            </app-global-network-dropdown>
          </ng-template>
        </span>

        <span
          class="high-contrast-theme pl-4"
          [ngClass]="{ 'pr-4': authStatus }"
        >
          <app-global-location-select
            class="w-[240px]"
            analytics
            [results]="locationAutosuggest.cities"
            [selectedOption]="locationAutosuggest.selectedLocation"
            [darkTheme]="true"
            appearance="fill"
            (termEntered)="locationAutosuggest.onLocationEntered($event)"
            (termSelected)="locationAutosuggest.onLocationSelect($event)"
            (emitBrowserLocationRequested)="
              locationAutosuggest.requestBrowserLocation()
            "
          >
          </app-global-location-select>
        </span>

        <span
          *ngIf="showMembersDropdown"
          class="high-contrast-theme w-[240px]"
          appUnfocus
        >
          <app-global-members-dropdown
            [darkTheme]="true"
          ></app-global-members-dropdown>
        </span>
      </div>
    </platform-page-container>
  </ng-container>
</div>

<!-- mobile -->
<ng-template #mobileContainer>
  <div>
    <!-- network selection dropdown (wizard) -->
    <app-network-selection-dropdown
      *ngIf="
        networkSelectionDropdownEnabled | async;
        else mobileNetworkDropdown
      "
      [darkTheme]="true"
      appearance="fill"
    >
    </app-network-selection-dropdown>

    <!-- non-wizard/default network selection dropdown -->
    <ng-template #mobileNetworkDropdown>
      <app-global-network-dropdown
        analytics
        [darkTheme]="true"
        [showTout]="true"
        [disableDropdown]="true"
        [hideFormField]="false"
        [showAlphaPrefixTout]="true"
        [mobile]="true"
        appearance="fill"
      >
      </app-global-network-dropdown>
    </ng-template>
  </div>

  <div class="mt-6 high-contrast-theme">
    <app-global-location-select
      analytics
      appearance="fill"
      [darkTheme]="true"
      [selectedOption]="locationAutosuggest.selectedLocation"
      (click)="openMobileAutosuggest()"
      (emitBrowserLocationRequested)="
        locationAutosuggest.requestBrowserLocation()
      "
    >
    </app-global-location-select>
  </div>

  <div
    class="mt-6 high-contrast-theme"
    *ngIf="authStatus && member?.dependents?.length > 1"
    appUnfocus
  >
    <app-global-members-dropdown
      [darkTheme]="true"
    ></app-global-members-dropdown>
  </div>
</ng-template>
